import ContactUs from '../components/ContactUs';
import Faq from '../components/Faq';
import Footer2 from '../components/Footer2';
import Header3 from '../components/Header3';
import Hero3 from '../components/Hero3';
import Portfolio2 from '../components/Portfolio2';
import Process2 from '../components/Process2';
import Services3 from '../components/Services3';
import Sponsors2 from '../components/Sponsors2';

function Home3() {
    return (
        <>
            <Header3 />
            <Hero3 />
            <Process2 />
            <Services3 />
            <Faq />
            <ContactUs />
            <Portfolio2 />
            <Sponsors2 />
            <Footer2 />
        </>
    );
}

export default Home3;
